import { DataItem } from '@pn/core/domain/data';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CompanyStatsState = {
  isFetching: boolean;
  isError: boolean;
  loadedCompanyIds: string[];
  companyStats: Record<string, DataItem[]>;
};

const initialState: CompanyStatsState = {
  isFetching: false,
  isError: false,
  loadedCompanyIds: [],
  companyStats: {},
};

export const createCompanyStatsSlice = (sliceName: string) =>
  createSlice({
    name: sliceName,
    initialState,
    reducers: {
      request: (state) => {
        state.isFetching = true;
        state.isError = false;
      },
      receive: (
        state,
        action: PayloadAction<{
          loadedCompanyId: string;
          stats: DataItem[];
        }>
      ) => {
        state.companyStats[action.payload.loadedCompanyId] =
          action.payload.stats;
        state.loadedCompanyIds = [
          ...state.loadedCompanyIds,
          action.payload.loadedCompanyId,
        ];
        state.isFetching = false;
      },
      error: (state) => {
        state.isFetching = false;
        state.isError = true;
      },
      reset: (state) => {
        state.isFetching = false;
        state.isError = false;
        state.companyStats = {};
      },
    },
  });

export const companyQuarterlyCorporateStatsSlice = createCompanyStatsSlice(
  'companyQuarterlyCorporateStats'
);
export const companyMonthlyStatsSlice = createCompanyStatsSlice(
  'companyMonthlyStats'
);
